import dayjs from 'dayjs';
import { createForm, useForm } from 'effector-forms';
import { useStore } from 'effector-react';
import { FormField, Select, TextInput, toaster } from 'evergreen-ui';
import { styled } from 'linaria/react';
import React, { useEffect } from 'react';
import { dateToInputValue } from 'src/common/date';
import { updateUserFx, user$ } from 'src/store/user.store';
import { Button } from 'src/ui/atoms/button';

const Details = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-column-gap: 16px;
	grid-row-gap: 16px;
	
	@media (max-width: 550px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;
const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 24px;
`;

const profileForm$ = createForm({
	fields: {
		first_name: {
			init: '',
		},
		last_name: {
			init: '',
		},
		phone: {
			init: '',
		},
		dob: {
			init: null as string | null,
		},
		sex: {
			init: null as string | null,
		},
		country: {
			init: null as string | null,
		},
		state: {
			init: null as string | null,
		},
		city: {
			init: null as string | null,
		},
		address: {
			init: null as string | null,
		},
		postal_code: {
			init: null as string | null,
		},
	},
});

export const ProfileInformationPage = () => {
	const user = useStore(user$);
	const profileForm = useForm(profileForm$);

	useEffect(() => {
		profileForm.setForm({
			first_name: user?.details.first_name,
			last_name: user?.details.last_name,
			dob: user?.details.dob,
			sex: user?.details.sex,
			country: user?.details.country,
			city: user?.details.city,
			phone: user?.details.phone,
			state: user?.details.state,
			address: user?.details.address,
			postal_code: user?.details.postal_code,
		});
	}, []);

	const handleSave = async () => {
		if (user === null) { return; }

		await updateUserFx({
			id: user.id,
			details: profileForm.values,
		});

		toaster.notify('Profile updated');
	};

	return (
		<>
			<Details>
				<FormField label={'First name'} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						value={profileForm.values.first_name}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.first_name.onChange(e.target.value)}

					/>
				</FormField>
				<FormField label={'Last name'} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						value={profileForm.values.last_name}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.last_name.onChange(e.target.value)}

					/>
				</FormField>
				<FormField label={'Phone'} style={{ gridColumn: '1 / 3' }} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						value={profileForm.values.phone}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.phone.onChange(e.target.value)}

					/>
				</FormField>
				<FormField label={'Date of birth'} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						type={'date'}
						value={profileForm.values.dob ? dayjs(profileForm.values.dob, 'YYYY-MM-DD').format('YYYY-MM-DD') : undefined as any}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.dob.onChange(dateToInputValue(e.target.value))}

					/>
				</FormField>
				<FormField label={'Sex'} className={'inputstyle'}>
					<Select
						width={'100%'}
						value={profileForm.values.sex || undefined}
						onChange={(e: React.ChangeEvent<HTMLSelectElement>) => profileForm.fields.sex.onChange(e.target.value === 'default' ? null : e.target.value)}
						className={'select-inputstyle'}

					>
						<option value={'default'}>Default</option>
						<option value="f">Female</option>
						<option value="m">Male</option>
					</Select>
				</FormField>
				<FormField label={'Country'} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						value={profileForm.values.country || undefined}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.country.onChange(e.target.value)}

					/>
				</FormField>
				<FormField label={'City'} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						value={profileForm.values.city || undefined}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.city.onChange(e.target.value)}

					/>
				</FormField>
				<FormField label={'Region'} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						value={profileForm.values.state || undefined}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.state.onChange(e.target.value)}

					/>
				</FormField>
				<FormField label={'Zip / Postal code'} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						value={profileForm.values.postal_code || undefined}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.postal_code.onChange(e.target.value)}

					/>
				</FormField>
				<FormField label={'Address'} style={{ gridColumn: '1 / 3' }} className={'inputstyle'}>
					<TextInput
						width={'100%'}
						value={profileForm.values.address || undefined}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => profileForm.fields.address.onChange(e.target.value)}

					/>
				</FormField>
			</Details>
			<ButtonContainer>
				<Button onClick={handleSave}>Save</Button>
			</ButtonContainer>
		</>
	);
};
